/* ==========================================================================
   AJÁNLATKOSÁR (quote cart) – localStorage alapú ajánlatkérési lista
   --------------------------------------------------------------------------
   Betöltés: layout/theme.liquid (MINDEN oldalon, defer-rel)
     <script src="{{ 'quote-cart.js' | asset_url }}" defer></script>

   Mit csinál:
   - Összegyűjti a [data-quote-add] gombokkal jelölt termékeket a böngésző
     localStorage-ébe (kulcs: mc_quote_cart), így a látogató több terméket is
     összeválogathat, majd EGY ajánlatkérésben elküldheti mindet.
   - MENNYISÉG (2026-08): a gomb data-quote-qty-from attribútumában megadott
     id-jú mezőből (tartalékként a legközelebbi [data-quote-qty-input] mezőből)
     olvassa ki, hány darabot kell hozzáadni. Ha nincs mező, 1 darab.
   - VÁLASZTÓ ABLAK (2026-08): ha a gombon ott a data-quote-choice jelölő,
     sikeres hozzáadás után felnyitja a [data-quote-choice-dialog] ablakot
     ("Tovább nézelődöm" / "Ajánlatkérés elküldése"). Ha ilyen ablak nincs az
     oldalon (a kosár szekció ki van kapcsolva), a régi, gombon megjelenő
     "Hozzáadva" visszajelzésre esik vissza.
   - VÁLTOZAT-SZINKRON (2026-08): a téma saját variant-picker komponensének
     'on:variant:change' eseményére frissíti a termékoldali gomb
     data-quote-id / -variant / -sku attribútumait (részletek lentebb, a
     VÁLTOZAT-SZINKRON blokknál).
   - A fejléc ikon és a lebegő gomb (launcher) csak akkor látszik, ha van tétel
     a listában. Mindkettő ugyanazokat a [data-quote-launcher] /
     [data-quote-count] attribútumokat viseli, a render() pedig
     querySelectorAll-lal MINDET kezeli – nem csak az elsőt.
   - A beküldés a Shopify beépített {% form 'contact' %} űrlapján megy, a
     tételek olvasható szövegként kerülnek a contact[Tetelek] rejtett mezőbe.
   - EGYETLEN ŰRLAP (2026-08): a snippets/quote-request.liquid termékenkénti
     felugró űrlapja megszűnt, csak a kosaras űrlap maradt. Az ehhez tartozó
     kód (.quote-dialog__form, mc_quote_submitted jelző, [data-quote-fields],
     termékoldali késleltetett beküldés) ebből a fájlból is törölve lett.
   - Spamvédelem a kosaras űrlapon: honeypot + időzár.

   BEKÜLDÉS UTÁNI ÁTIRÁNYÍTÁS (köszönőoldal) – 2026-08:
   - Az ajánlatkérő űrlap (sections/quote-basket.liquid – 2026-08 óta ez az
     EGYETLEN ilyen űrlap a témában) rejtett `return_to` mezőt küld a
     köszönőoldalra – ugyanazzal a megoldással, amit a
     sections/main-product.liquid 'product-signup' blokkja is használ.
   - A folyamat: az űrlap beküldése -> a Shopify a /pages/ajanlatkeres-koszonjuk
     oldalra irányít, és MAGA fűzi hozzá a ?contact_posted=true paramétert ->
     az oldalt a sections/quote-thank-you.liquid rendereli, ami kitesz egy
     [data-quote-thankyou] jelölőelemet.
   - Ha ezt a jelölőt megtaláljuk az oldalon, az initState() a sessionStorage
     jelzőktől FÜGGETLENÜL kiüríti a listát (ide csak tényleges beküldés után
     lehet eljutni), és újrarajzol, hogy a lebegő gomb is eltűnjön. Dialogot
     NEM nyitunk és in-dialog sikerüzenetet sem mutatunk: maga az oldal a
     visszaigazolás. Egyetlen ürítés fut le, mert ilyenkor a régi, jelző
     alapú sikerág (lásd lentebb) már el sem indul.
   - A dialogos sikerüzenet TARTALÉKNAK megmarad: ha a return_to valamiért nem
     érvényesül (app vagy téma felülírja), a látogató a termékoldalra tér
     vissza ?contact_posted=true paraméterrel, és a régi út változatlanul
     működik.

   JELZŐ (sessionStorage) – MINDEN takarítás EGY helyen, ebben a fájlban:
     mc_quote_basket_submitted : a kosaras űrlap SAJÁT beküldése
   (A régi mc_quote_submitted termékoldali jelzőt már senki nem írja, mert az
   az űrlap megszűnt – a hozzá tartozó kódot töröltük.)
   Formátum: '1|<időbélyeg ms>'. Minden oldalbetöltéskor pillanatképbe kerül
   a jelző, majd AZONNAL törlődik a sessionStorage-ből
   (MCQuoteCart.flags()). Ezért nem tud beragadni: ha a látogató a beküldés
   után egy idegen contact űrlapot küld be (kapcsolat oldal, hírlevél,
   termékértesítő), az onnan érkező contact_posted=true már nem üríti ki a
   listáját és nem nyit hamis sikerüzenetet. Ráadásul az 5 percnél régebbi
   jelző eleve érvénytelen (FLAG_TTL_MS).

   SPAMVÉDELEM:
   - honeypot: valódi bot jel -> csendes elutasítás (a bot sikerüzenetet lát,
     de semmi nem megy el).
   - időzár (2500 ms): a beküldést SOHA nem dobjuk el, csak elhalasztjuk a
     hátralévő idővel (közben a küldés gomb letiltva). Így az elgépelést
     javító, gyorsan újraküldő valódi ember kérése sem vész el nyomtalanul.
   - A dialog megnyitási időbélyege (__mcQuoteOpenedAt) csak EGYSZER áll be,
     és csak akkor, ha tényleg zárva volt: az újranyitás (hiba utáni
     visszanyitás, kézi zárás->nyitás) nem indítja újra az órát.

   Fontos: ez a fájl asset, ezért NEM használhat Liquid `| t` szűrőt. A
   feliratokat a szekció által kirenderelt JSON script tagből olvassa:
     <script type="application/json" data-quote-i18n>{ ... }</script>
   Ha hiányzik, angol alapértelmezésre esik vissza.

   Publikus API (window.MCQuoteCart):
     get() / add(item) / remove(id) / setQty(id, qty) / clear() / count()
     flags()  -> { basket: Boolean, posted: Boolean, basketPending: Boolean }
                 Az oldalbetöltés jelző-pillanatképe (a tárolóból már törölve).
   Minden módosítás után `mc:quote-cart:change` esemény száll a document-en.
   ========================================================================== */

(function () {
  'use strict';

  /* Kétszeres futás elleni védelem (pl. ha a szekció többször renderelődne) */
  if (window.__mcQuoteCartBound) return;
  window.__mcQuoteCartBound = true;

  var STORE_KEY = 'mc_quote_cart';            // localStorage: a lista
  var FLAG_BASKET = 'mc_quote_basket_submitted';  // sessionStorage: saját beküldés
  var FLAG_TTL_MS = 300000; // 5 perc – ennél régebbi jelző már érvénytelen
  var CHANGE_EVENT = 'mc:quote-cart:change';
  var MIN_FILL_MS = 2500;   // ennél gyorsabb kitöltés = gyanús -> késleltetés
  var ADDED_MS = 2000;      // meddig mutassa a "hozzáadva" feliratot
  var PULSE_MS = 600;       // a lebegő gomb villanásának hossza
  var DEFAULT_VARIANT = 'Default Title';   // ezt a változatnevet nem írjuk ki
  var MAX_QTY = 9999;       // épeszű felső korlát a mennyiség mezőre

  /* --- feliratok ---------------------------------------------------------- */
  var I18N_FALLBACK = {
    added_to_quote: 'Added',
    basket_remove: 'Remove',
    field_quantity: 'Quantity',
    /* a {{ count }} helyőrzőt a addedCountText() cseréli ki */
    added_count_one: '{{ count }} item is now in your quote request.',
    added_count_other: '{{ count }} items are now in your quote request.',
    sku: 'SKU'
  };
  var strings = null;

  function t() {
    if (strings) return strings;
    strings = {};
    var parsed = null;
    var el = document.querySelector('[data-quote-i18n]');
    if (el) {
      try { parsed = JSON.parse(el.textContent || el.innerHTML || '{}'); } catch (e) { parsed = null; }
    }
    for (var key in I18N_FALLBACK) {
      if (!Object.prototype.hasOwnProperty.call(I18N_FALLBACK, key)) continue;
      var val = parsed && typeof parsed[key] === 'string' ? parsed[key] : '';
      strings[key] = val !== '' ? val : I18N_FALLBACK[key];
    }
    return strings;
  }

  /* --- tároló: MINDEN hozzáférés try/catch-ben (privát mód, kvóta) --------- */
  function isArray(v) { return Object.prototype.toString.call(v) === '[object Array]'; }

  function readStore() {
    var raw = null;
    try { raw = localStorage.getItem(STORE_KEY); } catch (e) { return []; }
    if (!raw) return [];
    var arr = null;
    try { arr = JSON.parse(raw); } catch (e) { return []; }
    if (!isArray(arr)) return [];

    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var it = arr[i];
      if (!it || typeof it !== 'object') continue;
      var id = it.id == null ? '' : String(it.id);
      if (!id) continue;
      var qty = parseInt(it.qty, 10);
      if (!(qty > 0)) qty = 1;
      out.push({
        id: id,
        pid: it.pid == null ? '' : String(it.pid),
        title: it.title == null ? '' : String(it.title),
        variant: it.variant == null ? '' : String(it.variant),
        sku: it.sku == null ? '' : String(it.sku),
        url: it.url == null ? '' : String(it.url),
        image: it.image == null ? '' : String(it.image),
        qty: qty
      });
    }
    return out;
  }

  function writeStore(items, skipList) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(items)); } catch (e) {}
    render(items, skipList === true);
    dispatch(items);
  }

  function dispatch(items) {
    var ev;
    try {
      ev = new CustomEvent(CHANGE_EVENT, { bubbles: true, detail: { items: items, count: sumQty(items) } });
    } catch (e) {
      ev = document.createEvent('Event');
      ev.initEvent(CHANGE_EVENT, true, true);
      ev.detail = { items: items, count: sumQty(items) };
    }
    try { document.dispatchEvent(ev); } catch (e) {}
  }

  function sumQty(items) {
    var n = 0;
    for (var i = 0; i < items.length; i++) n += items[i].qty;
    return n;
  }

  function indexOfId(items, id) {
    for (var i = 0; i < items.length; i++) { if (items[i].id === String(id)) return i; }
    return -1;
  }

  /* --- jelzők (sessionStorage): írás, olvasás, EGYSZERI takarítás ---------- */
  function flagRead(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function flagClear(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  /* '1|<időbélyeg>' – az időbélyeg miatt tudjuk kiszűrni a régi jelzőt */
  function flagSet(key) {
    try { sessionStorage.setItem(key, '1|' + Date.now()); } catch (e) {}
  }

  /* Érvényes-e a jelző? A régi, időbélyeg nélküli '1' értéket is elfogadjuk. */
  function flagValid(raw) {
    if (!raw) return false;
    var parts = String(raw).split('|');
    if (parts[0] !== '1') return false;
    if (parts.length < 2) return true;          // régi formátum
    var ts = parseInt(parts[1], 10);
    if (!(ts > 0)) return false;
    return (Date.now() - ts) <= FLAG_TTL_MS;    // 5 percnél régebbi = érvénytelen
  }

  /* Az oldalbetöltés pillanatképe. A jelzőket MINDIG kiolvassuk ÉS töröljük –
     akkor is, ha nincs contact_posted=true az URL-ben, és akkor is, ha ezen az
     oldalon nincs ajánlatkérő dialog. Ez az EGYETLEN hely, ahol takarítunk. */
  var flagSnapshot = null;

  function flags() {
    if (flagSnapshot) return flagSnapshot;
    var posted = window.location.search.indexOf('contact_posted=true') !== -1;
    var rawBasket = flagRead(FLAG_BASKET);
    flagClear(FLAG_BASKET);
    flagSnapshot = {
      posted: posted,
      /* csak akkor számít saját beküldésnek, ha az URL is azt mondja */
      basket: posted && flagValid(rawBasket),
      /* nyers érvényesség (hibás beküldés utáni újrarendereléshez kell) */
      basketPending: flagValid(rawBasket)
    };
    return flagSnapshot;
  }

  /* --- publikus API ------------------------------------------------------- */
  var API = {
    get: function () { return readStore(); },

    add: function (item) {
      if (!item || !item.id) return readStore();
      var items = readStore();
      var idx = indexOfId(items, item.id);
      if (idx > -1) {
        items[idx].qty += item.qty > 0 ? item.qty : 1;
      } else {
        items.push({
          id: String(item.id),
          pid: item.pid == null ? '' : String(item.pid),
          title: item.title == null ? '' : String(item.title),
          variant: item.variant == null ? '' : String(item.variant),
          sku: item.sku == null ? '' : String(item.sku),
          url: item.url == null ? '' : String(item.url),
          image: item.image == null ? '' : String(item.image),
          qty: item.qty > 0 ? item.qty : 1
        });
      }
      writeStore(items);
      return items;
    },

    remove: function (id) {
      var items = readStore();
      var idx = indexOfId(items, id);
      if (idx > -1) items.splice(idx, 1);
      writeStore(items);
      return items;
    },

    setQty: function (id, qty, skipList) {
      var items = readStore();
      var idx = indexOfId(items, id);
      if (idx < 0) return items;
      var n = parseInt(qty, 10);
      if (!(n > 0)) n = 1;
      items[idx].qty = n;
      writeStore(items, skipList === true);
      return items;
    },

    clear: function () { writeStore([]); return []; },

    count: function () { return sumQty(readStore()); },

    /* A jelző pillanatképe (a tárolóból már törölve). Megtartjuk publikusnak:
       téma-testreszabások és külső szkriptek olvashatják. */
    flags: function () { return flags(); }
  };
  window.MCQuoteCart = API;

  /* --- megjelenítés ------------------------------------------------------- */
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function showVariant(variant) {
    return !!variant && variant !== DEFAULT_VARIANT;
  }

  function itemHtml(item, index) {
    var s = t();
    var id = esc(item.id);
    var html = '<li class="quote-basket__item" data-quote-item="' + id + '">';

    if (item.image) {
      html += '<img class="quote-basket__thumb" src="' + esc(item.image) + '" alt="" width="56" height="56" loading="lazy">';
    } else {
      html += '<span class="quote-basket__thumb quote-basket__thumb--empty" aria-hidden="true"></span>';
    }

    html += '<div class="quote-basket__text">';
    if (item.url) {
      html += '<a class="quote-basket__title" href="' + esc(item.url) + '">' + esc(item.title) + '</a>';
    } else {
      html += '<span class="quote-basket__title">' + esc(item.title) + '</span>';
    }
    if (showVariant(item.variant)) {
      html += '<span class="quote-basket__meta">' + esc(item.variant) + '</span>';
    }
    if (item.sku) {
      html += '<span class="quote-basket__meta">' + esc(s.sku) + ': ' + esc(item.sku) + '</span>';
    }
    html += '</div>';

    html += '<div class="quote-basket__controls">';
    html += '<input class="quote-basket__qty" type="number" min="1" step="1" inputmode="numeric"'
         + ' value="' + item.qty + '" data-quote-qty data-quote-id="' + id + '"'
         + ' aria-label="' + esc(s.field_quantity) + ' – ' + esc(item.title) + '">';
    html += '<button type="button" class="quote-basket__remove" data-quote-remove data-quote-id="' + id + '"'
         + ' aria-label="' + esc(s.basket_remove) + ' – ' + esc(item.title) + '" title="' + esc(s.basket_remove) + '">'
         + '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">'
         + '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
         + '</svg></button>';
    html += '</div></li>';

    return html;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
  }

  /* Üres listánál NEM néma preventDefault: eleve nem is látszik az űrlap.
     A látogató az üres állapot szövegét látja, tétel hozzáadásakor pedig
     azonnal visszakapja a kitölthető, engedélyezett űrlapot. */
  function syncBasketForms(count) {
    var forms = document.querySelectorAll('[data-quote-basket-form], .quote-basket__form');
    var empty = count === 0;
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      setHidden(form, empty);
      if (form.classList) {
        if (empty) form.classList.add('is-disabled'); else form.classList.remove('is-disabled');
      }
      var submitBtn = form.querySelector('[type="submit"]');
      /* a késleltetett (időzáras) beküldés alatt hagyjuk letiltva a gombot */
      if (submitBtn && !submitBtn.__mcQuoteDeferred) submitBtn.disabled = empty;
    }
  }

  function render(items, skipList) {
    if (!items) items = readStore();
    var count = sumQty(items);
    var i;

    /* tétellisták */
    if (!skipList) {
      var lists = document.querySelectorAll('[data-quote-basket-list]');
      for (i = 0; i < lists.length; i++) {
        var html = '';
        for (var j = 0; j < items.length; j++) html += itemHtml(items[j], j);
        lists[i].innerHTML = html;
      }
    }

    /* darabszám */
    var counters = document.querySelectorAll('[data-quote-count]');
    for (i = 0; i < counters.length; i++) counters[i].textContent = String(count);

    /* Fejléc ikon ÉS lebegő gomb: üres listánál mindkettő eltűnik.
       A sections/header.liquid linkje (.quote-header-link) és a
       sections/quote-basket.liquid lebegő gombja UGYANAZT a
       [data-quote-launcher] jelölést viseli, a querySelectorAll pedig MINDET
       visszaadja – tehát ez a ciklus mindkettőt kezeli. */
    var launchers = document.querySelectorAll('[data-quote-launcher]');
    for (i = 0; i < launchers.length; i++) {
      if (count === 0) {
        launchers[i].classList.add('is-empty');
        launchers[i].setAttribute('hidden', '');
      } else {
        launchers[i].classList.remove('is-empty');
        launchers[i].removeAttribute('hidden');
      }
    }

    /* üres állapot vs. lista */
    var empties = document.querySelectorAll('[data-quote-empty]');
    for (i = 0; i < empties.length; i++) setHidden(empties[i], count !== 0);
    var wraps = document.querySelectorAll('[data-quote-items]');
    for (i = 0; i < wraps.length; i++) setHidden(wraps[i], count === 0);

    /* sikerállapot feloldása: ha a sikeres beküldés után UGYANAZON az
       oldalbetöltésen új tétel kerül a listába, a kosár ne maradjon a holt
       sikerképernyőn – levesszük az is-submitted osztályt és visszarejtjük a
       sikerüzenetet, hogy a lista / üres állapot / űrlap újra látszódjon */
    if (count > 0) {
      var dialogs = document.querySelectorAll('dialog.quote-basket');
      for (i = 0; i < dialogs.length; i++) {
        dialogs[i].classList.remove('is-submitted');
        var okMsg = dialogs[i].querySelector('[data-quote-success]');
        if (okMsg) okMsg.setAttribute('hidden', '');
      }
    }

    /* űrlap: üres listánál elrejtve + letiltva, tételnél újra elérhető */
    syncBasketForms(count);
  }

  /* --- dialog nyitás / zárás (a quote-request.liquid mintájára) ------------ */
  /* Az időzár órája CSAK egyszer indul: ha a dialog tényleg zárva volt ÉS még
     nincs időbélyege. Az újranyitás (hiba utáni visszanyitás, kézi zárás után
     újranyitás) nem nullázza – különben a javítás után gyorsan újraküldő
     látogató minden alkalommal "túl gyors" lenne. */
  function stampOpened(dlg) {
    if (!dlg.__mcQuoteOpenedAt) dlg.__mcQuoteOpenedAt = Date.now();
  }

  function openDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) { dlg.showModal(); stampOpened(dlg); }
    } else {
      if (!dlg.hasAttribute('open')) { dlg.setAttribute('open', ''); stampOpened(dlg); }
    }
  }

  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  function basketDialog() { return document.querySelector('dialog.quote-basket'); }

  /* Köszönőoldal-jelölő: a sections/quote-thank-you.liquid rendereli ki
     (<div data-quote-thankyou hidden></div>) a /pages/ajanlatkeres-koszonjuk
     oldalon. Védekezőn: ha nincs ilyen elem (minden más oldal), null-t adunk
     vissza, és sosem dobunk hibát. */
  function thankYouMarker() {
    try { return document.querySelector('[data-quote-thankyou]'); } catch (e) { return null; }
  }

  /* A Shopify a sikeres contact beküldés után az oldal ÖSSZES contact
     űrlapjánál igazra állítja a form.posted_successfully? értéket. Ezért a nem
     ide tartozó sikerüzeneteket (pl. termékértesítő feliratkozás) elrejtjük –
     ezek a [data-quote-other-form] jelölést kapták. */
  function hideOtherFormMessages() {
    var others = document.querySelectorAll('[data-quote-other-form]');
    for (var i = 0; i < others.length; i++) {
      others[i].setAttribute('hidden', '');
      others[i].style.display = 'none';
    }
  }

  /* Sikerállapot: osztállyal kapcsoljuk, hogy a beküldés utáni újrarajzolás
     se hozhassa vissza az űrlapot / a tétellistát. Az osztályt a render()
     akkor veszi le, ha ÚJ tétel kerül a listába – így a kosár nem válik
     zsákutcává (lásd render()). */
  function showSuccess(dlg) {
    if (!dlg) return;
    dlg.classList.add('is-submitted');
    var ok = dlg.querySelector('[data-quote-success]');
    if (ok) ok.removeAttribute('hidden');
  }

  /* --- "hozzáadva" visszajelzés ------------------------------------------- */
  function flashAdded(btn) {
    if (!btn || btn.__mcQuoteTimer) return;   // dupla kattintás elleni védelem
    var original = btn.innerHTML;
    btn.classList.add('is-added');
    /* disabled: így a quote.css .quote-add[disabled] szabálya is érvényre jut,
       és a visszajelzés ideje alatt fizikailag sem lehet duplán kattintani */
    btn.disabled = true;
    btn.textContent = t().added_to_quote;
    btn.__mcQuoteTimer = setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove('is-added');
      btn.disabled = false;
      btn.__mcQuoteTimer = null;
    }, ADDED_MS);
  }

  function pulseLauncher() {
    var launchers = document.querySelectorAll('[data-quote-launcher]');
    for (var i = 0; i < launchers.length; i++) {
      (function (el) {
        el.classList.remove('is-pulse');
        /* reflow, hogy az animáció újraindulhasson */
        void el.offsetWidth;
        el.classList.add('is-pulse');
        setTimeout(function () { el.classList.remove('is-pulse'); }, PULSE_MS);
      })(launchers[i]);
    }
  }

  /* --- mennyiség beolvasása ------------------------------------------------
     Elsődlegesen a data-quote-qty-from attribútumban megadott id alapján
     keressük a mezőt (így a gomb és a mező távol is lehet egymástól a DOM-ban),
     tartalékként a gombhoz LEGKÖZELEBBI [data-quote-qty-input] mezőt. A felfelé
     keresést 6 szintre korlátozzuk, hogy egy másik blokk mezőjét véletlenül se
     olvassuk ki. Ha nincs mező (pl. termékkártyák), 1 darabot adunk hozzá. */
  function nearestQtyInput(btn) {
    var el = btn;
    var depth = 0;
    while (el && el.querySelector && depth < 6) {
      var found = el.querySelector('[data-quote-qty-input]');
      if (found) return found;
      el = el.parentElement;
      depth += 1;
    }
    return null;
  }

  function readQty(btn) {
    var input = null;
    var fromId = btn.getAttribute('data-quote-qty-from');
    if (fromId) {
      try { input = document.getElementById(fromId); } catch (e) { input = null; }
    }
    if (!input) input = nearestQtyInput(btn);
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    if (!(n > 0)) n = 1;
    if (n > MAX_QTY) n = MAX_QTY;
    n = Math.floor(n);
    /* a mezőbe visszaírjuk a ténylegesen hozzáadott értéket, hogy a látogató
       lássa, mi történt (pl. 0 vagy "abc" helyett 1) */
    if (String(n) !== String(input.value)) input.value = String(n);
    return n;
  }

  /* --- választó ablak ("hozzáadtuk – mit szeretnél most?") ------------------
     Markup: sections/quote-basket.liquid -> <dialog class="quote-choice"
     data-quote-choice-dialog>. Ha a kosár szekció ki van kapcsolva, ez az elem
     nincs az oldalon – ilyenkor false-szal térünk vissza, és a hívó a régi
     "Hozzáadva" gombfeliratra vált. */
  function choiceDialog() {
    try { return document.querySelector('[data-quote-choice-dialog]'); } catch (e) { return null; }
  }

  /* A darabszámos mondat a locales/*.json quote.added_count_one /
     quote.added_count_other kulcsaiból jön (a szekció data-quote-i18n JSON
     tagjén keresztül), bennük {{ count }} helyőrzővel. */
  function addedCountText(count) {
    var s = t();
    var tpl = count === 1 ? s.added_count_one : s.added_count_other;
    return String(tpl).replace(/\{\{\s*count\s*\}\}/g, String(count));
  }

  function openChoiceDialog(count) {
    var dlg = choiceDialog();
    if (!dlg) return false;
    var line = dlg.querySelector('[data-quote-choice-count]');
    if (line) line.textContent = addedCountText(count);
    openDialog(dlg);
    return true;
  }

  /* ==========================================================================
     VÁLTOZAT-SZINKRON (variant syncing)
     --------------------------------------------------------------------------
     A látogató az oldal betöltése UTÁN is válthat változatot a téma saját
     variant-picker komponensével, ilyenkor a termékoldali gomb
     data-quote-id / -variant / -sku attribútumai elavulnának: a
     snippets/quote-request.liquid blokkja NINCS [data-dynamic-variant-content]
     jelöléssel ellátva, tehát a variant-picker nem cseréli le.

     Milyen kapaszkodót ad az assets/variant-picker.js?
     1. announceChange() egy 'on:variant:change' CustomEvent-et küld
        (bubbles: true), detail = { form, variant, selectedOptions }. A
        detail.variant a `current_variant | json` objektum (id, title, sku,
        available, ...), amit a snippets/variant-picker.liquid renderel a
        <variant-picker> belsejébe egy [type="application/json"] tagbe.
        EZ az elsődleges kapaszkodó – a document-en figyeljük (buborékol).
     2. updateUrl() a címsort is átírja ?variant=<id> alakra
        (history.replaceState), ha a data-update-url nem 'false'. Ez a TARTALÉK.
     Kattintáskor mindkettőt újraellenőrizzük (a friss JSON tag a
     legmegbízhatóbb), végül a gomb eredeti attribútumaira esünk vissza.

     Csak a .quote-request blokkban lévő gombokat frissítjük: a termékkártyák
     gombjai szándékosan a szerver által renderelt (alap)változatot hordozzák.
     ========================================================================== */
  function variantScope(el) {
    if (!el || !el.closest) return null;
    return el.closest('.js-quickbuy, .cc-featured-product, .shopify-section') || null;
  }

  function applyVariant(btn, v) {
    if (!btn) return;
    if (!v || !v.id) {
      /* nincs érvényes változat (pl. hiányos kombináció) – ne engedjük, hogy
         elavult azonosítóval kerüljön tétel a listába */
      btn.setAttribute('data-quote-unavailable', '');
      btn.disabled = true;
      return;
    }
    btn.removeAttribute('data-quote-unavailable');
    if (!btn.__mcQuoteTimer) btn.disabled = false;
    btn.setAttribute('data-quote-id', String(v.id));
    btn.setAttribute('data-quote-variant', v.title == null ? '' : String(v.title));
    btn.setAttribute('data-quote-sku', v.sku == null ? '' : String(v.sku));
  }

  /* A <variant-picker> belsejébe rendelt JSON MINDIG az aktuális változat. */
  function variantFromPicker(scope) {
    if (!scope || !scope.querySelector) return null;
    var el = scope.querySelector('variant-picker [type="application/json"]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || '');
      return data && data.id ? data : null;
    } catch (e) { return null; }
  }

  function variantIdFromUrl() {
    var m = null;
    try { m = /[?&]variant=(\d+)/.exec(window.location.search || ''); } catch (e) { m = null; }
    return m ? m[1] : '';
  }

  /* Kattintás előtti utolsó ellenőrzés: JSON tag -> ?variant= -> a gomb eredeti
     attribútumai. Ha csak az URL-ből tudjuk az azonosítót, és az eltér a gombon
     lévőtől, a változatnevet és a cikkszámot ÜRESRE állítjuk: a hibás adat
     rosszabb, mint a hiányzó (a levélben "-" jelenik meg). */
  function syncBeforeAdd(btn) {
    if (!btn || !btn.closest || !btn.closest('.quote-request')) return;
    var v = variantFromPicker(variantScope(btn));
    if (v) { applyVariant(btn, v); return; }
    var urlId = variantIdFromUrl();
    if (!urlId || urlId === String(btn.getAttribute('data-quote-id') || '')) return;
    btn.setAttribute('data-quote-id', urlId);
    btn.setAttribute('data-quote-variant', '');
    btn.setAttribute('data-quote-sku', '');
  }

  document.addEventListener('on:variant:change', function (e) {
    var scope = variantScope(e && e.target ? e.target : null) || document;
    var v = (e && e.detail && e.detail.variant) || variantFromPicker(scope);
    var btns = scope.querySelectorAll('.quote-request [data-quote-add]');
    for (var i = 0; i < btns.length; i++) applyVariant(btns[i], v);
  });

  /* --- kattintások (delegálva) -------------------------------------------- */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    /* 1) listához adás */
    var addBtn = target.closest('[data-quote-add]');
    if (addBtn) {
      e.preventDefault();
      /* a változat-hármas (id, variant, sku) frissítése közvetlenül a
         hozzáadás előtt – lásd a VÁLTOZAT-SZINKRON blokkot */
      syncBeforeAdd(addBtn);
      if (addBtn.hasAttribute('data-quote-unavailable')) return;
      if (!addBtn.getAttribute('data-quote-id')) return;

      var addedItems = API.add({
        id: addBtn.getAttribute('data-quote-id'),
        pid: addBtn.getAttribute('data-quote-pid'),
        title: addBtn.getAttribute('data-quote-title'),
        variant: addBtn.getAttribute('data-quote-variant'),
        sku: addBtn.getAttribute('data-quote-sku'),
        url: addBtn.getAttribute('data-quote-url'),
        image: addBtn.getAttribute('data-quote-image'),
        qty: readQty(addBtn)
      });
      pulseLauncher();

      /* Választó ablak, ha a gomb kéri. Ha nincs ilyen ablak az oldalon (a
         kosár szekció ki van kapcsolva), a régi, gombon megjelenő "Hozzáadva"
         visszajelzésre esünk vissza – ahogy a data-quote-choice nélküli
         gomboknál is. */
      if (!addBtn.hasAttribute('data-quote-choice') || !openChoiceDialog(sumQty(addedItems))) {
        flashAdded(addBtn);
      }
      return;
    }

    /* 2) tétel törlése */
    var removeBtn = target.closest('[data-quote-remove]');
    if (removeBtn) {
      e.preventDefault();
      API.remove(removeBtn.getAttribute('data-quote-id'));
      return;
    }

    /* 3) lista ürítése */
    var clearBtn = target.closest('[data-quote-clear]');
    if (clearBtn) {
      e.preventDefault();
      API.clear();
      return;
    }

    /* 4) kosár megnyitása */
    var opener = target.closest('[data-quote-basket-open]');
    if (opener) {
      e.preventDefault();
      openDialog(basketDialog());
      return;
    }

    /* 5) kosár bezárása */
    var closer = target.closest('[data-quote-basket-close]');
    if (closer) {
      e.preventDefault();
      closeDialog(closer.closest('dialog'));
      return;
    }

    /* 6) választó ablak: "Tovább nézelődöm" -> csak bezárjuk */
    var choiceContinue = target.closest('[data-quote-choice-continue]');
    if (choiceContinue) {
      e.preventDefault();
      closeDialog(choiceContinue.closest('dialog'));
      return;
    }

    /* 7) választó ablak: "Ajánlatkérés elküldése" -> bezárjuk, és nyitjuk a
          kosarat, hogy a látogató egyből kitölthesse az űrlapot */
    var choiceSend = target.closest('[data-quote-choice-send]');
    if (choiceSend) {
      e.preventDefault();
      closeDialog(choiceSend.closest('dialog'));
      openDialog(basketDialog());
      return;
    }

    /* 8) háttérre kattintás = bezárás, de CSAK ha tényleg magára a dialogra
          esett a kattintás ÉS a belső doboz téglalapján kívülre. */
    if (target.tagName === 'DIALOG'
        && (target.classList.contains('quote-basket') || target.classList.contains('quote-choice'))) {
      if (e.clientX === 0 && e.clientY === 0) return;   // billentyűs "kattintás"
      var innerSel = target.classList.contains('quote-choice') ? '.quote-choice__inner' : '.quote-basket__inner';
      var inner = target.querySelector(innerSel);
      if (!inner) { closeDialog(target); return; }
      var r = inner.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(target);
    }
  });

  /* --- mennyiség módosítása ----------------------------------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-quote-qty]') : null;
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (!(qty > 0)) { qty = 1; input.value = '1'; }
    /* skipList = true: nem rajzoljuk újra a listát, hogy a fókusz megmaradjon */
    API.setQty(input.getAttribute('data-quote-id'), qty, true);
  });

  /* --- beküldés ------------------------------------------------------------ */
  function isBasketForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (form.hasAttribute && form.hasAttribute('data-quote-basket-form')) return true;
    return !!(form.classList && form.classList.contains('quote-basket__form'));
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) return url;
    var origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
    return origin + (url.charAt(0) === '/' ? '' : '/') + url;
  }

  function serialise(items) {
    var lines = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var variant = showVariant(it.variant) ? it.variant : '-';
      lines.push((i + 1) + ') ' + it.title
        + ' | ' + variant
        + ' | cikkszám: ' + (it.sku || '-')
        + ' | mennyiség: ' + it.qty
        + ' | ' + absoluteUrl(it.url));
    }
    return lines.join('\n');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isBasketForm(form)) return;

    var dlg = form.closest ? form.closest('dialog') : null;

    /* 1) honeypot: EZ az egyetlen valódi bot-jel. Csendes elutasítás: a bot
          ugyanazt a sikerüzenetet látja, de SEMMI nem megy el. */
    var hp = form.querySelector('[name="contact[Honeypot]"]');
    var filledHp = !!(hp && hp.value && hp.value.replace(/\s/g, '') !== '');
    if (filledHp) {
      e.preventDefault();
      showSuccess(dlg);
      return;
    }

    /* 2) üres listát nincs értelme elküldeni – ilyenkor az űrlap eleve rejtve
          van (syncBasketForms), ez csak a végső biztonsági háló. */
    var items = readStore();
    if (!items.length) {
      e.preventDefault();
      render(items);
      return;
    }

    /* 3) rejtett mezők feltöltése */
    var itemsField = form.querySelector('[name="contact[Tetelek]"]');
    if (itemsField) itemsField.value = serialise(items);
    /* TetelekSzama = ÖSSZ darabszám (ugyanaz, amit a lebegő gomb badge mutat),
       TetelekSorok = a különálló tételsorok száma. Ha a TetelekSorok mező nincs
       a markupban, itt hozzuk létre (a sections/quote-basket.liquid nem módosul). */
    var countField = form.querySelector('[name="contact[TetelekSzama]"]');
    if (countField) countField.value = String(sumQty(items));
    var rowsField = form.querySelector('[name="contact[TetelekSorok]"]');
    if (!rowsField) {
      rowsField = document.createElement('input');
      rowsField.type = 'hidden';
      rowsField.name = 'contact[TetelekSorok]';
      form.appendChild(rowsField);
    }
    rowsField.value = String(items.length);

    /* 4) innentől tudjuk, hogy a következő oldalbetöltés a MIÉNK (időbélyeggel) */
    flagSet(FLAG_BASKET);

    /* 5) időzár: a gyanúsan gyors beküldést NEM dobjuk el (az valódi kérést is
          elnyelne, pl. elgépelés javítása után), hanem elhalasztjuk annyival,
          amennyi a 2500 ms-ből még hátravan. A látogató csak annyit lát, hogy
          a küldés gomb egy pillanatra letiltódik. */
    var openedAt = dlg && dlg.__mcQuoteOpenedAt ? dlg.__mcQuoteOpenedAt : 0;
    var elapsed = openedAt ? (Date.now() - openedAt) : 0;
    if (elapsed < MIN_FILL_MS) {
      e.preventDefault();
      var wait = MIN_FILL_MS - elapsed;
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.__mcQuoteDeferred = true;
        submitBtn.disabled = true;
      }
      if (!form.__mcQuoteDeferTimer) {
        form.__mcQuoteDeferTimer = setTimeout(function () {
          form.__mcQuoteDeferTimer = null;
          /* a form.submit() NEM futtatja újra a HTML5 (required) ellenőrzést, és
             a mezők a várakozás alatt szerkeszthetők maradnak – ezért itt kézzel
             ellenőrzünk: hibás űrlapot nem küldünk el, hanem visszaadjuk a
             látogatónak (a küldés gomb újra aktív lesz). */
          if (form.checkValidity && !form.checkValidity()) {
            if (form.reportValidity) form.reportValidity();
            if (submitBtn) { submitBtn.__mcQuoteDeferred = false; submitBtn.disabled = false; }
            return;
          }
          try {
            form.submit();       // programozott beküldés: nem indít új submit eseményt
          } catch (err) {
            if (submitBtn) { submitBtn.__mcQuoteDeferred = false; submitBtn.disabled = false; }
          }
        }, wait);
      }
      return;
    }
  });

  /* --- bfcache (vissza gomb) ----------------------------------------------
     Visszalépéskor a DOMContentLoaded NEM fut újra, így a késleltetett beküldés
     miatt letiltott küldés gomb letiltva maradna (a __mcQuoteDeferred őr miatt
     a syncBasketForms sem nyúlna hozzá). Ezért itt eldobjuk a futó időzítőt,
     feloldjuk a gombot, majd újrarajzolunk. */
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    var forms = document.querySelectorAll('[data-quote-basket-form], .quote-basket__form');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.__mcQuoteDeferTimer) {
        clearTimeout(form.__mcQuoteDeferTimer);
        form.__mcQuoteDeferTimer = null;
      }
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.__mcQuoteDeferred = false;
        submitBtn.disabled = false;
      }
    }
    render();   /* a render() -> syncBasketForms állítja be a végleges állapotot */
  });

  /* Téma-szerkesztő: szekció újrarenderelése után a lebegő gombot és az
     üres/letiltott állapotokat újra szinkronizálni kell. */
  document.addEventListener('shopify:section:load', function () { render(); });

  /* --- oldalbetöltés ------------------------------------------------------- */
  function initState() {
    /* 0) KÖSZÖNŐOLDAL (/pages/ajanlatkeres-koszonjuk)
       Az űrlapok rejtett return_to mezője ide irányít beküldés után, a
       ?contact_posted=true paramétert a Shopify fűzi hozzá. Ide tehát csak
       tényleges beküldéssel lehet eljutni, ezért a listát a sessionStorage
       jelzőktől FÜGGETLENÜL ürítjük.
       - flags(): itt is kiolvassuk ÉS töröljük a jelzőket, hogy ne ragadjanak
         be egy későbbi oldalra (különben ott nyílna hamis sikerüzenet).
       - API.clear() magától újrarajzol (writeStore -> render), így a lebegő
         gomb és a darabszám is azonnal eltűnik.
       - AZONNAL visszatérünk: nem nyitunk dialogot és nem mutatunk in-dialog
         sikerüzenetet (maga az oldal a visszaigazolás), így a lentebbi
         sikerág sem fut le -> egyetlen ürítés, dupla lefutás nélkül. */
    if (thankYouMarker()) {
      flags();
      try {
        API.clear();
      } catch (e) {
        try { render(); } catch (e2) {}
      }
      hideOtherFormMessages();
      return;
    }

    render();

    /* A jelzők kiolvasása + törlése MINDIG megtörténik (flags()), akkor is, ha
       nincs contact_posted=true az URL-ben – így semmi nem tud beragadni. */
    var state = flags();

    /* Hibás beküldés: nincs contact_posted=true, de a MI űrlapunk kapott
       hibalistát -> nyissuk vissza a kosarat, hogy a látogató javíthasson.
       (Az időzár órája ilyenkor NEM indul újra – lásd stampOpened.) */
    if (!state.posted) {
      if (state.basketPending) {
        var errDlg = basketDialog();
        if (errDlg && errDlg.querySelector('[data-quote-errors]')) openDialog(errDlg);
      }
      return;
    }

    /* Idegen contact űrlapok sikerüzenetének elrejtése (lásd
       hideOtherFormMessages) – csak a MI beküldésünk után. */
    if (state.basket) hideOtherFormMessages();

    if (!state.basket) return;

    API.clear();                 // sikeres beküldés után a lista kiürül
    var dlg = basketDialog();
    if (!dlg) return;
    showSuccess(dlg);
    openDialog(dlg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initState);
  } else {
    initState();
  }
})();
